import { render, staticRenderFns } from "./IntroducerPlan.vue?vue&type=template&id=be5486a8"
import script from "./IntroducerPlan.vue?vue&type=script&lang=js"
export * from "./IntroducerPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports